import useBreakpoint from 'hooks/useBreakpoint';
import React, { useEffect, useState } from 'react';
import DownloadAppBannerDesktop, {
  DownloadAppBannerDesktopProps
} from './DownloadAppBannerDesktop';
import DownloadAppBannerDesktopRedirectQr from './DownloadAppBannerDesktopRedirectQr';
import DownloadAppBannerMobile from './DownloadAppBannerMobile';

interface DownloadAppBannerProps {
  downloadAppBannerDesktopProps?: DownloadAppBannerDesktopProps;

  /**
   * Choose between use default version of desktop banner or redirect to qr code page version.
   * - Default version: show QR code only at bottom center / right page
   * - Redirect to qr code version: show banner (like mobile version with Get the app button) fixed at bottom of page.
   * When user click Get the app button will redirect to QR code page instead of redirect to App Store / Play Store
   * because it doesn't work at desktop version. */
  useAppBannerDesktopRedirectQr?: boolean;
}

const DownloadAppBanner = ({
  downloadAppBannerDesktopProps = {},
  useAppBannerDesktopRedirectQr
}: DownloadAppBannerProps) => {
  const [attachDownloadBanner, setAttachedDownloadBanner] = useState(false);
  const { isMdScreen } = useBreakpoint();

  useEffect(() => {
    // Attach banner after 500ms to avoid banner height changes on load.
    const timeoutJob = setTimeout(() => {
      setAttachedDownloadBanner(true);
    }, 500);

    return () => {
      clearTimeout(timeoutJob);
    };
  }, []);

  if (!attachDownloadBanner) {
    return null;
  }

  if (isMdScreen) {
    return <DownloadAppBannerMobile />;
  }

  if (useAppBannerDesktopRedirectQr) {
    return <DownloadAppBannerDesktopRedirectQr />;
  }

  return <DownloadAppBannerDesktop {...downloadAppBannerDesktopProps} />;
};

export default DownloadAppBanner;
